<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mt-2 mb-3 flex">
        <li>
          <div class="cursor-pointer" @click="goBack">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
          </div>
        </li>
        <li>
          <h3>{{ $t("setup.label.edit_group_ticket") }}</h3>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <vx-card>
        <form @submit.prevent="updateTicket">
          <div class="vx-row">
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <!-- <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('customers.label.title')"
              > -->
              <vs-input
                :label="$t('customers.label.title')"
                v-model="ticket.title"
                class="w-full font-semibold mb-2"
                disabled
              />
              <!-- <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider> -->
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <!-- <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.groupName')"
              > -->
              <vs-input
                :label="$t('setup.label.groupName')"
                v-model="ticket.groupName"
                class="w-full font-semibold mb-2"
                disabled
              />
              <!-- <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider> -->
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <!-- <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.category')"
                > -->
                <small class="date-label">
                  {{ $t("customers.label.category") }}
                  <!-- <span class="required">*</span> -->
                </small>
                <v-select
                  :options="ticketTemplates && ticketTemplates.problemsDatas"
                  label="mCodeValue"
                  :reduce="(opt) => opt.id"
                  v-model="ticket.categoryId"
                  @input="onCategoryChange"
                  class="min-w-200 w-full mb-2"
                >
                  <template #option="{ mCodeValue }">{{ mCodeValue }}</template>
                </v-select>
                <!-- <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider> -->
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <!-- <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.sub_category')"
                > -->
                <small class="date-label">
                  {{ $t("customers.label.sub_category") }}
                  <!-- <span class="required">*</span> -->
                </small>
                <v-select
                  :options="subCategoryItem"
                  label="subCategory"
                  :reduce="(opt) => opt.id"
                  v-model="ticket.subcategoryId"
                  @input="onSubCategoryChange"
                  class="min-w-200 w-full mb-2"
                  disabled
                />
                <!-- <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider> -->
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full pb-5">
              <vs-input
                :label="$t('customers.label.ticket_date')"
                v-model="ticket.ticketDate"
                disabled
                class="w-full font-semibold"
              />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <!-- <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('customers.label.priority')"
              > -->
              <vs-input
                :label="$t('customers.label.priority')"
                v-model="ticket.severity"
                disabled
                class="w-full font-semibold mb-2"
              />
              <!-- <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider> -->
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("customers.label.source")
                }}</small>
                <v-select
                  :options="ticketTemplates.sourceData"
                  label="mCodeValue"
                  :reduce="(opt) => opt.name"
                  v-model="ticket.sourceOfTicket"
                  class="min-w-200 w-full mb-2"
                  :placeholder="$t('customers.label.SelectSource')"
                  disabled
                />
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full pb-5">
              <vs-input
                :label="$t('customers.label.due_time')"
                v-model="ticket.dueTime"
                disabled
                class="w-full font-semibold"
              />
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2 mt-3">
              <div class="dropdown-with-label">
                <small class="date-label">{{ $t("setup.label.city") }}</small>
                <!-- <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.city')"
                > -->
                <v-select
                  :options="
                    cityTemplate &&
                    cityTemplate.addressData &&
                    cityTemplate.addressData.cityDatas
                  "
                  label="cityName"
                  :placeholder="$t('setup.label.selectCity')"
                  multiple
                  v-model="ticket.affectedRegions"
                  disabled
                  :reduce="(cityName) => cityName.id"
                  class="min-w-200 w-full mb-2"
                />
                <!-- <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span> 
                </ValidationProvider> -->
              </div>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.Services")
                }}</small>
                <!-- <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Services')"
                > -->
                <v-select
                  label="value"
                  :options="serviceTemplates.serviceTypes"
                  :placeholder="$t('setup.label.SelectServices')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="ticket.serviceValues"
                  multiple
                  :reduce="(cityName) => cityName.id"
                  class="min-w-200 w-full mb-2"
                  disabled
                >
                </v-select>
                <!-- <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider> -->
              </div>
            </div>
            <!-- <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <flat-pickr
                :config="configdateTimePicker"
                v-model="ticket.dueTime"
                disabled
                class="w-full"
              />
            </div> -->
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("customers.label.description")
                }}</small>
                <!-- :label="$t('customers.label.description')" -->
                <!-- <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.description')"
                > -->
                <vs-textarea
                  class="w-full"
                  v-model="ticket.description"
                  rows="5"
                  disabled
                />
                <!-- <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider> -->
              </div>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.groupDescription")
                }}</small>
                <!-- <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.groupDescription')"
                > -->
                <!-- :label="$t('setup.label.groupDescription')" -->
                <vs-textarea
                  class="w-full"
                  v-model="ticket.groupDescription"
                  rows="5"
                  disabled
                />
                <!-- <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider> -->
              </div>
            </div>
            <div class="vx-col mt-4 md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.status')"
                >
                  <small class="date-label">
                    {{ $t("customers.label.status") }}
                    <span class="required">*</span>
                  </small>
                  <v-select
                    :options="statusOptions"
                    label="mCodeValue"
                    v-model="status"
                    class="min-w-200 w-full mb-2 starlabel"
                    :placeholder="$t('Select Status')"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('Resolution Summary')"
                >
                  <vs-input
                    :label="$t('Resolution Summary')"
                    v-model="resolutionSummary"
                    class="w-full font-semibold mb-2 starlabel"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <!-- <div class="dual-listbox-wrapper"> -->
          <!-- <div class="listbox">
              <div class="listbox-header">
                <h6>{{ $t("Linked Ticket") }}</h6>
              </div>
              <ul class="listbox-body">
                <li
                  v-for="t in filteredSourceGroupTickets"
                  :key="t.id"
                  @click="selectSource(t.id)"
                  :class="{ active: sourceSelection.includes(t.id) }"
                >
                  <label>
                    <input
                      type="checkbox"
                      :value="t.id"
                      v-model="sourceSelection"
                    />
                    {{ t.problemDescription }}
                  </label>
                </li>
              </ul>
            </div> -->

          <!-- <div
            class="listbox w-1/2"
            v-if="ticket.linkedTickets && ticket.linkedTickets.length"
          >
            <div class="listbox-header">
              <h6>{{ $t("Linked Ticket") }}</h6>
            </div>
            <ul class="listbox-body">
              <li
                v-for="ticketId in ticket.linkedTickets"
                :key="ticketId.ticketId"
                class="listbox-item"
              >
                <label>#{{ ticketId.ticketId }}</label>
                <feather-icon
                  icon="TrashIcon"
                  class="ml-2"
                  style="cursor: pointer; color: #e74c3c; float: right"
                  @click.stop="unlinkTicket(ticketId)"
                />
              </li>
            </ul>
          </div> -->
          <div v-if="ticket.linkedTickets && ticket.linkedTickets.length">
            <vs-table max-items="5" pagination :data="ticket.linkedTickets">
              <template slot="header">
                <div class="mr-2 mb-1 order-1"></div>
              </template>
              <template slot="thead">
                <vs-th>{{ $t("setup.label.TicketId") }}</vs-th>
                <vs-th>{{ $t("setup.label.LinkedAt") }}</vs-th>
                <vs-th>{{ $t("setup.label.Remarks") }}</vs-th>
                <vs-th class="tHeadCenter">{{
                  $t("customers.label.action")
                }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="index" :data="ticket" v-for="(e, index) in data">
                  <vs-td :data="e.ticketId">{{ e.ticketId }}</vs-td>
                  <vs-td :data="e.linkedAt"
                    >{{ getDate(e.linkedAt) }} {{ getTime(e.linkedAt) }}</vs-td
                  >
                  <vs-td :data="e.remarks">{{ e.remarks }}</vs-td>

                  <vs-td class="whitespace-no-wrap">
                    <div class="container_img">
                      <feather-icon
                        icon="TrashIcon"
                        title="Unlink"
                        svgClasses="w-5 h-5 text-danger stroke-current cursor"
                        @click.stop="unlinkTicket(e.ticketId)"
                        class="icon_row"
                      />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <!-- <div class="arrow-buttons">
              <button
                :disabled="!sourceSelection.length"
                @click="moveToTarget"
                class="arrow-button"
              >
                <feather-icon icon="ArrowRightIcon" />
              </button>
              <button
                :disabled="!targetSelection.length"
                @click="moveToSource"
                class="arrow-button"
              >
                <feather-icon icon="ArrowLeftIcon" />
              </button>
            </div> -->
          <!-- <div class="listbox">
              <div class="listbox-header">
                <h6>{{ $t("Unlinked Ticket") }}</h6>
              </div>
              <ul class="listbox-body">
                <li
                  v-for="t in filteredTargetGroupTickets"
                  :key="t.id"
                  @click="selectTarget(t.id)"
                  :class="{ active: targetSelection.includes(t.id) }"
                >
                  <label>
                    <input
                      type="checkbox"
                      :value="t.id"
                      v-model="targetSelection"
                    />
                    {{ t.problemDescription }}
                  </label>
                </li>
              </ul>
            </div> -->
          <!-- <div
              class="listbox"
              v-if="ticket.unlinkedTickets && ticket.unlinkedTickets.length"
            >
              <div class="listbox-header">
                <h6>{{ $t("Unlinked Ticket") }}</h6>
              </div>
              <ul class="listbox-body">
                <li v-for="ticketId in ticket.unlinkedTickets" :key="ticketId">
                  <label> #{{ ticketId.ticketId }} </label>
                  <feather-icon
                    icon="TrashIcon"
                    class="ml-2"
                    style="cursor: pointer; color: #e74c3c; float: right"
                    @click.stop="linkTicket(ticketId)"
                  />
                </li>
              </ul>
            </div> -->
          <!-- </div> -->
          <div class="center mt-4">
            <vs-button type="border mr-2" @click="goBack">{{
              $t("customers.label.cancel")
            }}</vs-button>
            <vs-button type="filled" @click="updateTicket">{{
              $t("setup.label.Update")
            }}</vs-button>
          </div>
        </form>
      </vx-card>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import ValidationPopup from "@/components/ValidationPopup.vue";
import moment from "moment";

export default {
  name: "EditGroupingTicket",
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ValidationPopup,
  },
  data() {
    return {
      ticket: {
        id: null,
        title: "",
        description: "",
        categoryId: null,
        subcategoryId: null,
        severity: "",
        status: "",
        sourceOfTicket: "",
        ticketDate: "",
        dueTime: "",
        groupName: "",
        groupDescription: "",
        affectedRegions: null,
        serviceValues: [],
        linkedTickets: [],
        unlinkedTickets: [],
      },
      status: null,
      resolutionSummary: "",
      ticketsInit: { sourceTickets: [], targetTickets: [] },
      showTickets: false,
      searchSource: "",
      searchTarget: "",
      sourceSelection: [],
      targetSelection: [],
      errorMessage: "",
      warningPopup: false,
      warningText: "",
      configdateTimePicker: { enableTime: true, dateFormat: "d m Y H:i:S" },
    };
  },
  computed: {
    ...mapState({
      ticketTemplates: (s) => s.entity.ticketTemplate,
      subCategoryItem: (s) => s.entity.ticketSubcategory,
      groupTickets: (s) => s.groupTicketing.groupTickets,
      cityTemplate: (state) => state.entity.template,
      serviceTemplates: (state) => state.serviceProducts.serviceTemplate,
      formattedDate: (s) => s.settings.selectedDateFormat,
    }),
    statusOptions() {
      return [{ mCodeValue: "CLOSED" }, { mCodeValue: "RESOLVED" }];
    },
    filteredSourceGroupTickets() {
      return this.searchSource
        ? this.ticketsInit.sourceTickets.filter((t) =>
            t.problemDescription
              .toLowerCase()
              .includes(this.searchSource.toLowerCase())
          )
        : this.ticketsInit.sourceTickets;
    },
    filteredTargetGroupTickets() {
      return this.searchTarget
        ? this.ticketsInit.targetTickets.filter((t) =>
            t.problemDescription
              .toLowerCase()
              .includes(this.searchTarget.toLowerCase())
          )
        : this.ticketsInit.targetTickets;
    },
  },
  watch: {
    "ticket.city"() {
      if (
        this.ticket.city &&
        this.ticket.problemCode &&
        this.ticket.subCategory
      ) {
        this.getTickets();
      }
    },
    "ticket.problemCode"() {
      if (
        this.ticket.city &&
        this.ticket.problemCode &&
        this.ticket.subCategory
      ) {
        this.getTickets();
      }
    },
    "ticket.subCategory"() {
      if (
        this.ticket.city &&
        this.ticket.problemCode &&
        this.ticket.subCategory
      ) {
        this.getTickets();
      }
    },
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    getTime(time) {
      return moment(time).format("HH:mm:ss");
    },
    async getTemplate() {
      try {
        await this.$store.dispatch("entity/setTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchGroupById() {
      const id = this.$route.params.id;
      const resp = await this.$store.dispatch(
        "groupTicketing/getGroupTicketById",
        id
      );
      Object.assign(this.ticket, {
        id: resp.id,
        title: resp.title,
        description: resp.description,
        categoryId: Number(resp.categoryId),
        subcategoryId: Number(resp.subcategoryId),
        severity: resp.severity,
        status: resp.status,
        groupName: resp.groupName,
        dueTime:
          resp.dueTime || moment().add(1, "days").format("DD MM YYYY HH:mm:ss"),
        groupDescription: resp.groupDescription,
        affectedRegions: resp.affectedRegions || resp.city,
        serviceValues: resp.affectedServices,
        sourceOfTicket: resp.sourceOfTicket || "CRM System",
        ticketDate: moment().format("DD MM YYYY HH:mm:ss"),
        linkedTickets: resp.linkedTickets || [],
        unlinkedTickets: resp.unlinkedTickets || [],
      });
      this.resolutionSummary= resp.resolutionSummary,
      this.status= resp.status,
      this.getSubCategory(resp.categoryId);
      await this.loadGroupTickets();
      const existing = this.groupTickets.filter((t) =>
        resp.ticketIds.includes(t.id)
      );
      this.ticketsInit.targetTickets = existing;
      this.ticketsInit.sourceTickets = this.groupTickets.filter(
        (t) => !resp.ticketIds.includes(t.id)
      );
      if (this.ticket.city) {
        this.showTickets = true;
      } else this.showTickets = false;
    },
    async loadGroupTickets() {
      const payload = {
        region: this.ticket.affectedRegions,
        categoryId: this.ticket.categoryId,
        subCategoryId: this.ticket.subcategoryId,
      };
      await this.$store.dispatch("groupTicketing/getGroupTickets", payload);
      this.$set(this, "ticketsInit", {
        sourceTickets: this.groupTickets,
        targetTickets: [],
      });
    },
    onCategoryChange(catId) {
      this.ticket.subcategoryId = null;
      this.$store.dispatch("entity/setTicketSubcategory", catId);
      this.loadGroupTickets();
    },
    onSubCategoryChange(subId) {
      const obj = this.subCategoryItem.find((s) => s.id === subId);
      this.ticket.severity = obj.priority;
      if (obj.timetaken) {
        this.ticket.dueTime = moment()
          .add(obj.timetaken, "hours")
          .format("DD MM YYYY HH:mm:ss");
      }
      this.loadGroupTickets();
    },
    selectSource(id) {
      const idx = this.sourceSelection.indexOf(id);
      idx === -1
        ? this.sourceSelection.push(id)
        : this.sourceSelection.splice(idx, 1);
    },
    selectTarget(id) {
      const idx = this.targetSelection.indexOf(id);
      idx === -1
        ? this.targetSelection.push(id)
        : this.targetSelection.splice(idx, 1);
    },
    moveToTarget() {
      const toMove = this.ticketsInit.sourceTickets.filter((t) =>
        this.sourceSelection.includes(t.id)
      );
      this.ticketsInit.targetTickets.push(...toMove);
      this.ticketsInit.sourceTickets = this.ticketsInit.sourceTickets.filter(
        (t) => !this.sourceSelection.includes(t.id)
      );
      this.sourceSelection = [];
    },
    moveToSource() {
      const toMove = this.ticketsInit.targetTickets.filter((t) =>
        this.targetSelection.includes(t.id)
      );
      this.ticketsInit.sourceTickets.push(...toMove);
      this.ticketsInit.targetTickets = this.ticketsInit.targetTickets.filter(
        (t) => !this.targetSelection.includes(t.id)
      );
      this.targetSelection = [];
    },
    async updateTicket() {
      const valid = await this.$refs.observer.validate();
      if (!valid) return;
      const payload = {
        id: this.$route.params.id,
        payload: {
          status: this.status.mCodeValue,
          resolutionSummary: this.resolutionSummary,
        },
      };
      try {
        await this.$store.dispatch("groupTicketing/updateGroupTicket", payload);
        this.$swal({
          title: "Updated",
          text: "Group ticket updated",
          icon: "success",
        });
        this.goBack();
      } catch (e) {
        this.errorMessage = e.message;
        this.warningPopup = true;
      }
    },
    async getServiceTemplateFunc() {
      try {
        await this.$store.dispatch("serviceProducts/setServiceTemplate");
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async unlinkTicket(ticketId) {
      const id = this.$route.params.id;
      try {
        await this.$store.dispatch("groupTicketing/UnlinkTicket", {
          id,
          payload: {
            groupTicketId: id,
            remarks: "Network Outage",
            ticketIds: [ticketId],
          },
        });
        this.$swal({
          title: "Unlinked",
          text: "Ticket unlinked successfully",
          icon: "success",
        });
        await this.fetchGroupById();
      } catch (e) {
        this.errorMessage = e.message;
        this.warningPopup = true;
      }
    },
    async linkTicket(ticketId) {
      const id = this.$route.params.id;
      try {
        await this.$store.dispatch("groupTicketing/linkTicket", {
          id,
          payload: {
            groupTicketId: id,
            remarks: "Network Outage",
            ticketIds: [ticketId.ticketId],
          },
        });
        this.$swal({
          title: "Linked",
          text: "Ticket Linked successfully",
          icon: "success",
        });
        this.fetchGroupById();
      } catch (e) {
        this.errorMessage = e.message;
        this.warningPopup = true;
      }
    },
    async getTicketTemplate() {
      try {
        await this.$store.dispatch("entity/setTicketTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getSubCategory(categoryId) {
      try {
        if (categoryId) {
          this.$store.dispatch("entity/setTicketSubcategory", categoryId);
        } else {
          this.$store.commit("entity/SET_TICKET_SUBCATEGORY", []);
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  async mounted() {
    await this.getTicketTemplate();
    await this.fetchGroupById();
    await this.getTemplate();
    await this.getServiceTemplateFunc();
  },
};
</script>

<style scoped lang="scss">
.rule-card {
  height: 300px;
  min-width: 250px;
  background-color: cornsilk;
  border: 1px solid #ede4e4;
}
.header-plan {
  margin-left: 2.5rem;
  font-weight: 500;
  font-size: large;
}
.header-text {
  margin-left: 1rem;
  font-weight: 500;
  font-size: medium;
}
.search-box {
  border: 1px solid #c4bfbf;
}
.tag-approval {
  border: 2px solid rgb(14, 140, 224);
  color: rgb(23, 180, 228);
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.dual-listbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
}
.listbox {
  width: -webkit-fill-available;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  background: #fff;
  display: flex;
  flex-direction: column;
}
.listbox-header {
  background-color: #2e68b266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.listbox-body {
  overflow-y: auto;
  flex-grow: 1;
  margin: 0;
  padding: 10px;
  list-style: none;
}
.listbox-item {
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}
.listbox-item:hover {
  background-color: #f0f8ff;
}
.listbox-item.active {
  background-color: #e2e9f5;
  font-weight: bold;
}
.arrow-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.arrow-button {
  padding: 8px;
  border: none;
  background-color: #eee;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0;
}
.arrow-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
